import React from 'react';
import { CloseCircleIcon } from '@stockx/icons';
import { SearchBoxSite } from '@app/catalog';
import { MobileSearchBar, MobileSearch } from './Search.styles';

interface NavMobileSearchProps {
  handleMobileSearchClick: () => void;
}

const Search: React.FC<NavMobileSearchProps> = ({
  handleMobileSearchClick,
}) => {
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleMobileSearchClick();
    }
  };

  return (
    <>
      <MobileSearchBar className="navbar-search">
        <SearchBoxSite />
      </MobileSearchBar>

      <MobileSearch>
        <div
          className="search-toggle"
          onClick={handleMobileSearchClick}
          onKeyPress={handleKeyPress}
          role="button"
          tabIndex={0}
          aria-label="close search"
        >
          <CloseCircleIcon boxSize="6" />
        </div>
      </MobileSearch>
    </>
  );
};

export default Search;
